import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export function* setConcentration() {
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { concentration, medicationAdministered, addMedicationAdministeredData } = addMedicationAdministeredState
  const selectedMedication = addMedicationAdministeredData.filter(
    (medication) => medication.key === medicationAdministered?.key
  )
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].concentration = concentration
    yield put(setAddMedicationAdministeredData(addMedicationAdministeredData))
  }
}
export function* setConcentrationSaga() {
  yield takeLatest([AddMedicationAdministeredConstants.SET_CONCENTRATION], setConcentration)
}
